import { render, staticRenderFns } from "./RecommendBlog.vue?vue&type=template&id=1495f5ec&scoped=true"
import script from "./RecommendBlog.vue?vue&type=script&lang=js"
export * from "./RecommendBlog.vue?vue&type=script&lang=js"
import style0 from "./RecommendBlog.vue?vue&type=style&index=0&id=1495f5ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1495f5ec",
  null
  
)

export default component.exports